module.exports = __webpack_public_path__ + "media/components/assets/img/logo-flyo-0666234c2be7a4d47b2dcafe1afd0c95.svg";